'use client'

import React, { forwardRef, ForwardedRef } from 'react'
import clsx from 'clsx'

import { Swiper, SwiperRef } from 'swiper/react'

import {
  Autoplay,
  EffectFade,
  Pagination,
  Navigation,
  EffectCreative,
} from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/effect-creative'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import { SliderProps } from './Slider.types'

const Slider = forwardRef<SwiperRef, SliderProps>(
  (
    { config = {}, totalSlides, children, className, ...rest }: SliderProps,
    ref: ForwardedRef<SwiperRef>
  ) => {
    const { autoplay = false, withPagination = true, ...otherConfig } = config
    let modules = [EffectFade, EffectCreative]
    if (autoplay) modules = [...modules, Autoplay, Navigation]
    if (!!totalSlides && withPagination) modules = [...modules, Pagination]

    return (
      <Swiper
        ref={ref}
        className={clsx(className)}
        modules={modules}
        autoplay={autoplay}
        {...otherConfig}
        {...rest}
      >
        {children}
      </Swiper>
    )
  }
)

// Add displayName for better debugging in React DevTools
Slider.displayName = 'Slider'

export default Slider
